import styled from "@emotion/styled";
import { Table } from "@mui/material";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ReactComponent as ChatBubbleIcon } from "assets/mail-chat-bubble-square-warning.svg";
import { Link } from "react-router-dom";
import { tokens } from "styles/Tokens";
import Scroller from "./Scroller/InfiniteScroller";
import ToolTip from "./Tooltip";
import Typography from "./Typography";

export const StyledLink = styled(Link)`
  font-family: Noto Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-decoration: none;
  color: ${tokens.Text.General.PrimaryHeadline};
`;

export default function BasicTable(props: any) {
  const {
    isTablePaginated = true,
    noDataIcon = <ChatBubbleIcon />,
    noDataMessage = "There is no data",
    scrollableTarget = "tableDiv",
    sx = {}
  } = props;

  const fetchMore = () => {
    props?.pagination?.setPageNo(props?.pagination?.pageNo + 1);
  };

  const MyTable = (
    <TableContainer elevation={0} component={Paper} sx={sx}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {props?.data?.headers?.map((item: any, index: any) => {
              return <TableCell key={item.id}>{item.content}</TableCell>;
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.data?.rows?.length ? (
            props?.data?.rows?.map((row: any, index: any) => {
              return (
                <TableRow key={row.id} sx={{ "&:last-child td": { border: 0 } }}>
                  {row?.data?.map((item: any, index: any) => {
                    return (
                      <ToolTip key={row.id} variant="info" listDetails={item.tooltip}>
                        <TableCell
                          component="td"
                          scope="row"
                          sx={{
                            color: tokens.Text.General.PrimaryHeadline,
                            cursor: item.tooltip ? "pointer" : ""
                          }}
                        >
                          {item?.to ? (
                            <StyledLink to={`${item?.to}`}>{item.content ?? "-"}</StyledLink>
                          ) : (
                            <Typography
                              component={"div"}
                              variant={"body2"}
                              showBold={item.showBold}
                              color={item.color}
                              sx={{
                                overflow: "hidden",
                                maxWidth: "400px",
                                width: "fit-content",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: "2",
                                WebkitBoxOrient: "vertical"
                              }}
                            >
                              {item.content ?? "-"}
                            </Typography>
                          )}
                        </TableCell>
                      </ToolTip>
                    );
                  })}
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={props?.data?.headers?.length}>
                <Stack
                  spacing={3}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ backgroundColor: tokens.Background.General.Secondary, padding: "40px 24px" }}
                >
                  {noDataIcon}
                  <Typography variant="body1" color={tokens.Text.General.Tertiary}>
                    {noDataMessage}
                  </Typography>
                </Stack>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );

  if (!isTablePaginated) {
    return MyTable;
  } else {
    return (
      <Scroller
        scrollableTarget={scrollableTarget}
        dataLength={props?.dataLength || props?.data?.rows?.length || 0}
        loadMore={fetchMore}
        totalList={props.totalRecords}
        label="records"
        footerStyle={{ marginY: "16px" }}
      >
        {MyTable}
      </Scroller>
    );
  }
}
